<style src="./EmptyItem.scss" lang="scss"></style>

<template lang="pug">
  mixin content()
    .empty-item__cover
      .empty-item__create
        Icon(
          name='create'
        )
    .empty-item__headline(
      v-if='label'
    )
      h4.empty-item__name {{ label }}

  router-link.empty-item(
    v-if='href'
    :to='href'
    :title='label || title || null'
  )
    +content

  button.empty-item(
    v-else-if='action'
    @click='action'
    :title='label || title || null'
  )
    +content
</template>
<script>
import Icon from "@/components/Icon/Icon";

export default {
  name: "EmptyItem",
  props: {
    label: String,
    href: String,
    title: String,
    action: Function
  },
  components: {
    Icon
  }
};
</script>
